import React, { useEffect, useState } from "react";
import Button from "../../common/button/button";
import { setError } from "../../common/toast/toast";
import Row from "../../common/layout/row";
import ContentCardHeader from "../../common/template/contentCardHeader";
import Select from "../../common/form/select";
import { LabelSelectUcIconeGestor } from "../../common/form/LabelSelectUcIconeGestor";
import Grid from "../../common/layout/grid";
import { ModalFiltrosFaturasAdmAgua } from "./ModalFiltrosFaturasAdmAgua";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";

import { getListaFaturasAdm, setFiltro } from "../faturaActions";

function FiltrosFaturasAdmEnergiaComponent(props) {
    useEffect(() => {
        if (props.filtro.id_cliente && !props.listaCliente.find((cli) => cli.id == props.filtro.id_cliente)) {
            props.setFiltro({
                ...props.filtro,
                id_cliente: null,
                unidades_consumidoras: [],
            });
        }
    }, []);

    const [modalFiltrosAberto, setModalFiltrosAberto] = useState(false);

    return (
        <>
            <ModalFiltrosFaturasAdmAgua visible={modalFiltrosAberto} handleClose={() => setModalFiltrosAberto(false)} {...props} />
            <ContentCardHeader>
                <Row style={{ paddingBlock: 15 }}>
                    {props.usuarioLogado && !props.usuarioLogado.acesso_cliente ? (
                        <Select
                            readOnly={props.aguardando}
                            name="id_cliente"
                            options={props.listaCliente}
                            label="Cliente"
                            cols="12 6 6 6"
                            placeholder="Selecione o Cliente"
                            value={props.filtro.id_cliente}
                            onChange={(value) => {
                                if (!parseInt(props.filtro.ano) && !parseInt(props.filtro.mes) && !parseInt(value) && !props.filtro.unidades_consumidoras.length) {
                                    return setError("Selecione um cliente, uma UC ou algum período para poder limpar o filtro");
                                }
                                props.setFiltro({
                                    ...props.filtro,
                                    id_cliente: value,
                                    unidades_consumidoras: [],
                                });
                                props.getListaFaturasAdm();
                            }}
                        />
                    ) : null}

                    <Select
                        readOnly={props.aguardando}
                        name="ano"
                        options={Array.from({ length: new Date().getFullYear() - 2015 + 1 }, (v, i) => ({
                            id: 2015 + i,
                            valor: 2015 + i,
                        }))}
                        label="Ano"
                        cols="12 6 3 3"
                        placeholder="Selecione o ano"
                        value={props.filtro.ano}
                        onChange={(value) => {
                            if (!parseInt(props.filtro.id_cliente) && !parseInt(props.filtro.mes) && !parseInt(value) && !props.filtro.unidades_consumidoras.length) {
                                return setError("Selecione um cliente, uma UC ou algum período para poder limpar o filtro");
                            }
                            props.setFiltro({
                                ...props.filtro,
                                ano: value,
                            });
                            props.getListaFaturasAdm();
                        }}
                    />

                    <Select
                        readOnly={props.aguardando}
                        name="mes"
                        options={props.listaMeses}
                        label="Mês"
                        cols="12 6 3 3"
                        placeholder="Selecione o mês"
                        value={props.filtro.mes}
                        onChange={(value) => {
                            if (!parseInt(props.filtro.id_cliente) && !parseInt(props.filtro.ano) && !parseInt(value) && !props.filtro.unidades_consumidoras.length) {
                                return setError("Selecione um cliente, uma UC ou algum período para poder limpar o filtro");
                            }
                            props.setFiltro({
                                ...props.filtro,
                                mes: value,
                            });
                            props.getListaFaturasAdm();
                        }}
                    />

                    <Select
                        readOnly={props.aguardando}
                        options={props.listaUnidadeConsumidora}
                        label={
                            <LabelSelectUcIconeGestor
                                isMulti={true}
                                filtro={props.filtro}
                                listaUnidadeConsumidora={props.listaUnidadeConsumidora}
                                setExibirModal={(ucFiltro) =>
                                    props.setState({
                                        ...props.filtroState,
                                        exibirModalGestorConcessionaria: true,
                                        itemSelecionado: ucFiltro,
                                    })
                                }
                            />
                        }
                        cols="12 12 9 9"
                        placeholder="Selecione as UCs"
                        isMulti={true}
                        value={props.filtro.unidades_consumidoras}
                        onChange={(ucsSelecionadas) => {
                            if (!parseInt(props.filtro.id_cliente) && !parseInt(props.filtro.mes) && !parseInt(props.filtro.ano) && !ucsSelecionadas.length) {
                                return setError("Selecione um cliente, uma UC ou algum período para poder limpar o filtro");
                            }
                            props.setFiltro({
                                ...props.filtro,
                                unidades_consumidoras: [...ucsSelecionadas],
                            });
                            props.getListaFaturasAdm();
                        }}
                    />
                    <Select
                        readOnly={props.aguardando}
                        name="id_concessionaria"
                        options={props.listaConcessionaria}
                        label="Concessionária"
                        cols="12 12 3 3"
                        placeholder="Selecione a concessionaria"
                        value={props.filtro.id_concessionaria}
                        onChange={(id_concessionaria) => {
                            props.setFiltro({
                                ...props.filtro,
                                id_concessionaria,
                            });
                            props.getListaFaturasAdm();
                        }}
                    />
                </Row>
                <Row style={{ padding: 7 }}>
                    <Grid cols="12 12 4 2" style={{ display: "flex", justifyContent: "center", paddingBlock: 8, margin: 0, cursor: "pointer" }}>
                        <Button
                            title="Filtros"
                            disabled={props.aguardando}
                            icon="fas fa-filter"
                            text="Filtros"
                            type={"light"}
                            solid={true}
                            forceBoxShadow={true}
                            event={() => setModalFiltrosAberto(true)}
                        />
                    </Grid>
                    {(props.buttons || []).map((botao, i) => (
                        <Grid key={i} cols="12 12 4 2" style={{ display: "flex", justifyContent: "center", paddingBlock: 8, margin: 0, cursor: "pointer" }}>
                            {botao}
                        </Grid>
                    ))}
                </Row>
            </ContentCardHeader>
        </>
    );
}
const mapStateToProps = (state) => {
    return {
        usuarioLogado: state.auth.usuarioLogado,
        aguardando: state.fatura.aguardando,
        filtro: state.fatura.filtro,
        listaMeses: state.fatura.listaMeses,
        listaCliente: state.fatura.listaClienteAgua,
        listaConcessionaria: state.fatura.listaConcessionariaAgua,
    };
};

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            setFiltro,
            getListaFaturasAdm,
        },
        dispatch
    );
const FiltrosFaturasAdmAgua = connect(mapStateToProps, mapDispatchToProps)(FiltrosFaturasAdmEnergiaComponent);
export { FiltrosFaturasAdmAgua };
